// node-modules
import 'letteringjs';

// others
import { Lerper } from '@/scripts/utils';

const defaults = {
  element: null,
  space: 8,
  char: '[class*="char"]',
};

export default class HoverLetterSpacing {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.element = options.element;
    this.$element = $(this.element);
    if (!this.element) return;
    this.space = options.space;
    this.charSelector = options.char;
    this.chars = [];
    this.pair = null;
    this.middle = null;

    this.lerper = null;

    this.init();
  }

  update(value) {
    this.lerper.setValue(value);
  }

  destroy() {
    this.lerper.destroy();
  }

  addEvents() {
    this.lerper = new Lerper({
      onTick: (value) => {
        let p = 1;
        const start = this.pair ? this.middle : this.middle - 1;
        for (let i = start; i >= 0; i -= 1) {
          const mult = (this.pair && p === 1) ? 0.5 : p;
          $(this.chars[i]).css({
            transform: `translateX(-${this.space * mult * value}px)`,
          });
          $(this.chars[this.middle + p]).css({
            transform: `translateX(${this.space * mult * value}px)`,
          });
          p += 1;
        }
      },
    });
  }

  init() {
    this.$element.text((i, text) => text.trim()).lettering();
    this.chars = this.element.querySelectorAll(this.charSelector);
    this.pair = this.chars.length % 2 === 0;
    this.middle = Math.ceil(this.chars.length / 2) - 1;
    this.addEvents();
  }
}




// WEBPACK FOOTER //
// ./scripts/utils/HoverLetterSpacing.js